import React, { useEffect } from 'react';
import useMetaLayoutContext from 'Components/UI/Meta/MetaForm/Components/MetaLayoutContext';
import { MetaResourceRenderer } from 'Components/UI/Meta/MetaForm/Components/MetaResourceRenderer';
import { FDStack } from '@facet-wealth/design';
import { useLayoutContext } from 'Context/LayoutContext';
import { Content } from './Content';
import { PlannerInsightChatLayout } from '../PlannerInsightChat/layout';
import PlannerInsightChatMetaOverrideSet from '../PlannerInsightChat/metaOverrideSet';
import { RoadmapDeliverableWrapperLayout } from '../Wrapper/RoadmapDeliverableWrapperLayout';


const RoadmapDeliverableLayout = () => {
  const { resource } = useMetaLayoutContext();
  const { setNavigationVisible } = useLayoutContext();

  const PlannerInsightChat = (
    <MetaResourceRenderer
      resource={resource} // has attrs for cfp insight
      layout={PlannerInsightChatLayout}
      metaOverrideSet={PlannerInsightChatMetaOverrideSet}
    />
  );

  useEffect(() => {
    setNavigationVisible(false);
  }, [setNavigationVisible]);

  return (
    <RoadmapDeliverableWrapperLayout>
      <FDStack direction={'column'} spacing={5} width={'100%'} maxWidth={600}>
        {PlannerInsightChat}
        <Content />
      </FDStack>
    </RoadmapDeliverableWrapperLayout>
  );
};

RoadmapDeliverableLayout.defaultProps = {
};

RoadmapDeliverableLayout.propTypes = {
};

export default RoadmapDeliverableLayout;
